import PropTypes from 'prop-types';
import React, { useMemo, useCallback, useEffect } from 'react';
import {
  NewBookingConfigPropType,
  NewBookingDeliveryDetailPropType,
} from 'common/prop-types';
import _get from 'lodash/get';
import NewBookingDuck from 'ducks/new-booking-duck';
import ScribeDuck from 'ducks/scribe-duck';
import { getDeliveryFinalDropOffs } from 'helper/anytime-booking';
import { getUserCountryCodeFromState } from 'selectors/app-selector';
import { connect } from 'react-redux';
import ServiceTypeSectionUI from '../common-section-ui/service-type-section-ui';
import generateServiceTypesToRender from '../common-logic/service-type';

const ServiceTypesSection = ({
  dispatch,
  deliveryID,
  deliveryDetail,
  config,
  countryCode,
}) => {
  const isRoundTrip = _get(deliveryDetail, 'isRoundTrip', false);
  const dropOffs = useMemo(() => getDeliveryFinalDropOffs(deliveryDetail), [
    deliveryDetail,
  ]);
  const selectedServiceType = _get(deliveryDetail, 'configuration.serviceType');
  const selectedSpecialServiceType = _get(
    deliveryDetail,
    'configuration.specialServiceType',
  );
  const selectedServiceTypeKey =
    selectedServiceType && selectedSpecialServiceType
      ? `${selectedServiceType}-${selectedSpecialServiceType}`
      : undefined;

  const serviceTypes = _get(config, 'serviceTypes', []);
  const serviceTypesToRender = useMemo(
    () => generateServiceTypesToRender(serviceTypes, dropOffs, countryCode),
    [serviceTypes, dropOffs, countryCode],
  );

  const onServiceTypeClick = useCallback(
    ({ serviceType, specialServiceType }) => {
      dispatch(
        NewBookingDuck.creators.updateServiceConfig(deliveryID, {
          serviceType,
          specialServiceType,
        }),
      );

      dispatch(
        ScribeDuck.creators.scribeExpressDeliveryDeliveryType(serviceType),
      );
    },
    [dispatch, deliveryID],
  );

  // auto select INSTANT for MSD
  useEffect(
    () => {
      if (
        !selectedServiceType &&
        ((dropOffs && dropOffs.length > 1) || isRoundTrip)
      ) {
        const st = serviceTypes.find(st => st.id === 'INSTANT');
        if (st) {
          const sst = st.specialServices.find(sst => sst.id === 'None');
          onServiceTypeClick({
            serviceType: st.id,
            specialServiceType: sst.id,
          });
        }
      }
    },
    [
      dropOffs,
      serviceTypes,
      isRoundTrip,
      selectedServiceType,
      onServiceTypeClick,
    ],
  );

  return (
    <ServiceTypeSectionUI
      onServiceTypeClick={onServiceTypeClick}
      selectedServiceTypeKey={selectedServiceTypeKey}
      serviceTypesToRender={serviceTypesToRender}
    />
  );
};

ServiceTypesSection.propTypes = {
  config: NewBookingConfigPropType.isRequired,
  deliveryDetail: NewBookingDeliveryDetailPropType.isRequired,
  deliveryID: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  countryCode: PropTypes.string.isRequired,
};

export default connect(state => ({
  countryCode: getUserCountryCodeFromState(state),
}))(ServiceTypesSection);
